const RootPath = window.g.baseUrl
const apis = {
  /* 客户 api */
  getCustomers: RootPath + 'plugin/crm/customer/index',
  // 根据客户ID获取项目
  getCustomer: RootPath + 'plugin/crm/customer/getForm',
  // 保存客户
  saveCustomer: RootPath + 'plugin/crm/customer/save',
  // 批量删除客户
  delCustomers: RootPath + 'plugin/crm/customer/delBatches'
}

export default apis
